// Fixed bar pinned to the bottom of the viewport. Offsets itself by the sidebar width (--sb set in Layout)
// on large screens, respects iOS safe-area insets, and renders a spacer so page content is never hidden under it.
export default function FloatingBar({ children, testid = "floating-bar" }) {
  return (
    <>
      <div aria-hidden className="no-print" style={{ height: "calc(4.5rem + env(safe-area-inset-bottom))" }} />
      <div data-testid={testid}
        className="no-print fixed bottom-0 left-0 right-0 lg:left-[var(--sb,15rem)] z-30 bg-white/95 backdrop-blur border-t border-slate-200 shadow-[0_-6px_20px_rgba(15,23,42,0.10)] px-3 sm:px-6 lg:px-8 pt-2.5 transition-[left] duration-200"
        style={{ paddingBottom: "calc(0.625rem + env(safe-area-inset-bottom))" }}>
        <div className="flex items-center gap-2 flex-wrap">{children}</div>
      </div>
    </>
  );
}
